interface SummaryBlockProps {
  children: React.ReactNode;
}

const SummaryBlock = ({ children }: SummaryBlockProps) => {
  return (
    <div className="rounded-md bg-secondary px-5 py-4 mb-6 font-body text-sm leading-relaxed text-foreground/80">
      <p className="text-xs font-medium uppercase tracking-wide text-accent mb-1">In plain English</p>
      <div>{children}</div>
    </div>
  );
};

export default SummaryBlock;